import React, {
    useEffect,
    useState,
  } from 'react';
  import moment from 'moment';
  import styles from './TotalVisits.module.scss';
  import {TailSpin} from 'react-loader-spinner';
  import {useTranslation} from "react-i18next";
  import DateTabs from "../DateTabs/DateTabs";
  import ProfileVisitChart from '../../../Charts/ProfileVisitChart';
  import useRequest from '../../../../API/request';
  
  const TotalVisits = () => {
    const {t} = useTranslation();
    const [data, setData] = useState(false);
    const [value, setValue] = useState([]);
    const [total, setTotal] = useState(0);
    const [stackedData, setStackedData]= useState<{stackValues: {name: string, data: number[]}[], stackLabels: string[]}>({stackValues: [], stackLabels: []});
    const stackRequest = useRequest({method: 'GET', url: '/analytics/profile/visits'});
  
    const getProfileVisitsAnalyticsData = async () => {
      try {
        const params = {
          startDate: moment(`${moment(value[0]).format('YYYY-MM-DD')} 00:00:00`, 'YYYY-MM-DD HH:mm:ss').toISOString(),
          endDate: moment(`${moment(value[1]).format('YYYY-MM-DD')} 23:59:59`, 'YYYY-MM-DD HH:mm:ss').toISOString(),
          offset: (new Date()).getTimezoneOffset(),
        };
        const stackResult: {visits: {[key: string]: {count: string, date: string}[]}, total: number} = await stackRequest.doRequest(params);
        if (stackResult?.visits) {
          const keys: string[] = Object.keys(stackResult?.visits); // Seperate keys for x-axis 
          const profileVisitsArray: number[] = [];
          Object.values(stackResult?.visits).map((ele: {count: string, date: string}[]) => {
            profileVisitsArray.push(parseInt(ele[0]?.count as string));
          });
          const stackValues: {name: string, data: number[]}[] = [{name: 'Visits', data: profileVisitsArray}] || [];
          const stackLabels: string[] = keys || [];
          setStackedData({stackValues, stackLabels});
          setTotal(stackResult?.total);
          setData(true);
        } else {
          setData(true);
        }
      } catch (error) {
        setData(true);
        console.log('Error occured', error);
      }
    };
  
    useEffect(() => {
        if (value.length) {
          getProfileVisitsAnalyticsData();    
        }
    }, [value]);
  
    return (
      <div className={styles.total_clicks_social_media_wrapper}>
          <div className={styles.total_clicks_wrapper}>
            <div className={styles.description_select_wrapper}>
            <div className={styles.heading}><p>{t('total_visits')}</p><p className={styles.total}>{total?.toLocaleString()}</p></div>
                <DateTabs handleChange={setValue} />
            </div>
  
            <div className={styles.chart_wrapper}>
              {data ? <ProfileVisitChart values={stackedData.stackValues} labels={stackedData.stackLabels} /> :
              <div style={{position: 'relative'}}>
                <div style={{position: 'absolute', top: '20%', right: '45%'}}>
                  <TailSpin color="#EB3B5A" height={80} width={80} />
                </div>
                <ProfileVisitChart values={[]} labels={[]} />
              </div>
              }
            </div>
          </div>
        </div>
    );
  };
export default TotalVisits;
